var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "onboarding-step" }, [
    _c("div", { staticClass: "onboarding-step-wrap" }, [
      _c("div", { staticClass: "onboarding-block-wrap" }, [
        _c("div", { staticClass: "onboarding-block-head" }, [
          _c("h4", { staticClass: "onboarding-step-heading" }, [
            _vm._v(" Personal Information "),
          ]),
          _c(
            "span",
            {
              staticClass: "onboarding-link_item",
              on: { click: _vm.goToPreviousStep },
            },
            [_vm._v("Edit")]
          ),
        ]),
        _c("ul", { staticClass: "onboarding-list" }, [
          _c("li", [
            _c("span", { staticClass: "onbaording-heading" }, [
              _vm._v("First Name"),
            ]),
            _c("span", { staticClass: "onbaording-text" }, [
              _vm._v(_vm._s(_vm.form?.firstName)),
            ]),
          ]),
          _c("li", [
            _c("span", { staticClass: "onbaording-heading" }, [
              _vm._v("Last Name"),
            ]),
            _c("span", { staticClass: "onbaording-text" }, [
              _vm._v(_vm._s(_vm.form?.lastName)),
            ]),
          ]),
          _c("li", [
            _c("span", { staticClass: "onbaording-heading" }, [
              _vm._v("Email"),
            ]),
            _c("span", { staticClass: "onbaording-text" }, [
              _vm._v(_vm._s(_vm.form?.email)),
            ]),
          ]),
          _c("li", [
            _c("span", { staticClass: "onbaording-heading" }, [
              _vm._v("Phone number"),
            ]),
            _c("span", { staticClass: "onbaording-text" }, [
              _vm._v(_vm._s(_vm.formatPhoneNumber(_vm.form?.phoneNumber))),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "onboarding-block-wrap" }, [
        _c("div", { staticClass: "onboarding-block-head" }, [
          _c("h4", { staticClass: "onboarding-step-heading" }, [
            _vm._v(" Emergency contact information "),
          ]),
          _c(
            "span",
            {
              staticClass: "onboarding-link_item",
              on: { click: _vm.goToPreviousStep },
            },
            [_vm._v("Edit")]
          ),
        ]),
        _c("ul", { staticClass: "onboarding-list" }, [
          _c("li", [
            _c("span", { staticClass: "onbaording-heading" }, [
              _vm._v("First Name"),
            ]),
            _c("span", { staticClass: "onbaording-text" }, [
              _vm._v(_vm._s(_vm.form?.emergencyContact?.firstName)),
            ]),
          ]),
          _c("li", [
            _c("span", { staticClass: "onbaording-heading" }, [
              _vm._v("Last Name"),
            ]),
            _c("span", { staticClass: "onbaording-text" }, [
              _vm._v(_vm._s(_vm.form?.emergencyContact?.lastName)),
            ]),
          ]),
          _c("li", [
            _c("span", { staticClass: "onbaording-heading" }, [
              _vm._v("Phone number"),
            ]),
            _c("span", { staticClass: "onbaording-text" }, [
              _vm._v(
                _vm._s(
                  _vm.formatPhoneNumber(_vm.form?.emergencyContact?.phoneNumber)
                )
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "onboarding-sticky-btn-holder" }, [
      _c(
        "div",
        { staticClass: "onboarding-sticky-btn-wrap" },
        [
          _c("UiButton", {
            staticClass: "my-6 block w-full",
            attrs: {
              variant: "black",
              buttonText: "Submit",
              fullWidth: "",
              processing: _vm.loading,
            },
            on: { click: _vm.submit },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }